module.exports = __webpack_public_path__ + "static/media/phone-icon.07a2ac15.svg";